/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useEffect, useContext, useState } from 'react';
import { Button, Form, FormGroup, Label, Input, Col } from 'reactstrap';
import moment from 'moment';
import Alert from 'react-s-alert';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext'

// import services
import AdminService from '../../services/AdminService';
import GeneralService from '../../services/GeneralService';

// local imports
import ErrorBoundary from '../general/ErrorBoundary';

const ProviderPayments = props => {

    // states
    const [providers, setProviders] = useState([]);
    const [selectedProvider, setSelectedProvider] = useState({ provider: {}, sessionList: [] });
    const [totalAmount, setTotalAmount] = useState(-1);
    const [searchData, setSearchData] = useState({ providerId: '', fromDate: moment().format('YYYY-MM-DD'), toDate: moment().format('YYYY-MM-DD') })
    const [isLoading, setIsLoading] = useState(false);

    // contexts
    const { theme } = useContext(ThemeContext);

    // use Effects
    useEffect(() => {
        AdminService.getProviders(null, null, null).then(data => {
            try {
                setProviders(data.providers);
            } catch (err) {
                Alert.error("Some error occured, please try again later or report support team.", {
                    position: 'top-right',
                    effect: 'slide'
                });
                GeneralService.logError('at Admin ProviderPayments useEffect', 'Error in try catch block', err.stack);
            }
        });
        return () => { setProviders(); setSelectedProvider(); }
    }, []);

    // handle functions
    const handleSubmit = e => {
        e.preventDefault();
        try {
            setIsLoading(true);
            AdminService.getProviderPayments(searchData).then(data => {
                setSelectedProvider({ ...selectedProvider, provider: data.provider, sessionList: data.sessionList });
                var total = 0;
                data.sessionList.forEach(element => {
                    total += parseFloat(element.paymentId.payment.amount);
                });
                setTotalAmount(total.toFixed(2));
                setIsLoading(false);
            });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            setIsLoading(false);
            GeneralService.logError('at Admin ProviderPayments handleSubmit', 'Error in try catch block', err.stack);
        }
    }

    return (
        <main>
            <div className="container-fluid">
                <h3 className="my-4">Counsellor Payments</h3>
                <div className="card mb-4">
                    <div className="card-header">
                        Payment details for counsellor
                    </div>
                    <div className="card-body">
                        <Form onSubmit={handleSubmit}>
                            <label className="mb-4">
                                Select counsellor from the dropdown below to view payment details
                            </label>
                            <FormGroup row>
                                <Label sm={3} for="providers">Counsellor</Label>
                                <Col sm={6}>
                                    <Input type="select" name="providers" id="providers" onChange={(e) => setSearchData({ ...searchData, providerId: e.target.value === '' ? '' : providers[e.target.value]._id })} required>
                                        <option value="">Select counsellor</option>
                                        {
                                            providers.map((item, index) => (
                                                <option key={index} value={index}>{item.title ? item.title : ''} {item.firstName} {item.lastName}</option>
                                            ))
                                        }
                                    </Input>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={3} for="from">From date</Label>
                                <Col sm={6}>
                                    <Input type="date" name="from" id="from" value={searchData.fromDate} onChange={(e) => setSearchData({ ...searchData, fromDate: e.target.value })} required />
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={3} for="to">To date</Label>
                                <Col sm={6}>
                                    <Input type="date" name="to" id="to" value={searchData.toDate} onChange={(e) => setSearchData({ ...searchData, toDate: e.target.value })} required />
                                </Col>
                            </FormGroup>
                            <Button type="submit" className="btn my-2" style={theme.button} disabled={isLoading}>{isLoading ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Search</Button>
                        </Form>
                        {
                            selectedProvider.sessionList.length ?
                                <div className="card-body py-0">
                                    <div className="table-responsive">
                                        <table className="table table-bordered mb-0" id="dataTable" width="100%" cellSpacing="0">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: '1%' }}>Sr no.</th>
                                                    <th>Session Date</th>
                                                    <th>Client</th>
                                                    <th>Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    selectedProvider.sessionList.map((item, index) => (
                                                        <ErrorBoundary errorAt={`At Admin ProviderPayments Table${index}`}>
                                                            <tr key={index}>
                                                                <td>{index + 1}</td>
                                                                <td>{item.date}</td>
                                                                <td>{item.title ? item.title : ''} {item.client.firstName} {item.client.lastName}</td>
                                                                <td>{item.paymentId.payment.amount}</td>
                                                            </tr>
                                                        </ErrorBoundary>
                                                    ))
                                                }
                                            </tbody>
                                            <tfoot>
                                                <tr style={{ fontWeight: '500' }}>
                                                    <td className="text-right" colSpan='3'>Total</td>
                                                    <td>{totalAmount}</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                                :
                                totalAmount === 0 ?
                                    <h3 className="text-center">No data found</h3>
                                    : null
                        }
                    </div>
                </div>
            </div>
        </main>
    )

}

export default ProviderPayments;